export default __webpack_public_path__ + "static/featured-image-bc26487ee6c2f43e2499bb7c1807c486.jpg";